<ng-container *ngIf="!allProvidersPage">
  <div class="lobby_group--header swiper_header lobby-header--providers lobby-header--providers--{{providerGroupNameString}}">
    <h2 class="lobby_group--title">{{ providerGroupName | translate }}</h2>
    <div class="lobby_group--nav" [ngClass]="{ 'lobby_group--nav-show' : isToShowButtons() }">
            <div class="swiper-button-prev swiper-button-disabled lobby_game--providers-prev lobby_game--providers-prev--{{providerGroupNameString}}"></div>
            <div class="swiper-button-next swiper-button-disabled lobby_game--providers-next lobby_game--providers-next--{{providerGroupNameString}}"></div>
    </div>
</div>
  <div class="">
    <div class="">
      <div class="">
        <div class="lobby_game--providers lobby_game--providers--{{providerGroupNameString}} swiper  swiper-container clearfix" [config]="swiperDefaultConfig">
          <div class="swiper-wrapper">
            <ng-container *ngFor="let provider of gameProviderMap">
                <div class="providers__list swiper-slide" >
                  <a class="providers__wrap"
                      (click)="goToProviderGames(provider.vendorId)">
                      <img src="{{siteUrlPath}}/{{mediaUrlPath}}/games/providers/logo-{{provider.vendorId}}.svg"  alt="{{provider.vendorDisplayName}}"/>
                  </a>
                </div>
              
            </ng-container>      
          </div>
        </div>
  
      </div>
    </div>

  </div>
</ng-container>

<ng-container *ngIf="allProvidersPage">
    <div class="providers__list allProvidersPageBtn" *ngFor="let provider of gameProviderMap | getValues">
      <a class="providers__wrap"
          (click)="goToProviderGames(provider.key)">
          <img src="{{siteUrlPath}}/{{mediaUrlPath}}/games/providers/logo-{{provider.key}}.svg"  alt="{{provider.val}}"/>
      </a>
    </div>
</ng-container>